/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Missing_Ellipses_LabelInputs */

const en_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing Ellipses`)
};

const fr_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points de suspension manquants`)
};

const de_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlende Auslassungspunkte`)
};

const it_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellissi mancanti`)
};

const ru_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсутствующие эллипсы`)
};

const es_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elipses faltantes`)
};

const zh_cn2_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺失的省略号`)
};

const ja_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`省略記号が欠落している`)
};

const hi_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लुप्त दीर्घवृत्त`)
};

const pt_pt2_style_guide_manager_missing_ellipses_label = /** @type {(inputs: Style_Guide_Manager_Missing_Ellipses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elipses Ausentes`)
};

/**
* | output |
* | --- |
* | "Missing Ellipses" |
*
* @param {Style_Guide_Manager_Missing_Ellipses_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_missing_ellipses_label = /** @type {((inputs?: Style_Guide_Manager_Missing_Ellipses_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Missing_Ellipses_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "de") return de_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "it") return it_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "es") return es_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_missing_ellipses_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_missing_ellipses_label(inputs)
	return en_style_guide_manager_missing_ellipses_label(inputs)
});